import React, { useState, useEffect } from 'react';

const UserForm = ({ existingData, onSave, onCancel }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('user');

  const isEditing = !!existingData;

  useEffect(() => {
    if (existingData) {
      setName(existingData.name || '');
      setEmail(existingData.email || '');
      setRole(existingData.role || 'user');
      setPassword(''); // Kosongkan password saat edit, hanya diisi jika ingin diubah
    } else {
      // Reset form untuk mode tambah
      setName('');
      setEmail('');
      setPassword('');
      setRole('user');
    }
  }, [existingData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !email || (!isEditing && !password)) {
        alert('Nama, Email, dan Password wajib diisi untuk user baru.');
        return;
    }
    onSave({ name, email, password, role });
  };

  return (
    <form onSubmit={handleSubmit} className="form-card">
      <div className="form-group">
        <label>Nama Lengkap</label>
        <input 
          type="text" 
          value={name} 
          onChange={(e) => setName(e.target.value)} 
          required 
        />
      </div>
      <div className="form-group">
        <label>Email</label>
        <input 
          type="email" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
          required 
        />
      </div>
      <div className="form-group">
        <label>Password</label>
        <input 
          type="password" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
          placeholder={isEditing ? "Kosongkan jika tidak ingin diubah" : ""}
          required={!isEditing} // Password wajib hanya saat membuat user baru
        />
      </div>
      <div className="form-group">
        <label>Role</label>
        <select value={role} onChange={(e) => setRole(e.target.value)} required>
          <option value="user">User (Read Only)</option>
          <option value="operator">Operator (Input/Edit)</option>
          <option value="superadmin">Superadmin (Akses Penuh)</option>
        </select>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #f0f0f0' }}>
        <button type="button" onClick={onCancel} className="btn-secondary">Batal</button>
        <button type="submit" className="btn-primary">Simpan</button>
      </div>
    </form>
  );
};

export default UserForm;